var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2714_3531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.29 19.2826L16.4125 18.4041C16.3185 18.3098 16.201 18.2421 16.0722 18.2082L14.0631 17.6804C13.8847 17.6335 13.7298 17.5224 13.6281 17.3685C13.5264 17.2146 13.4851 17.0286 13.5119 16.846L13.735 15.3273C13.754 15.1991 13.8058 15.078 13.8855 14.9758C13.9652 14.8736 14.07 14.7938 14.1897 14.7442L17.0444 13.5573C17.1763 13.5025 17.3211 13.4866 17.4618 13.5113C17.6024 13.5361 17.7331 13.6005 17.8384 13.697L20.1569 15.8167",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.73438 17.3109L5.66437 16.6997C5.76737 16.6316 5.85198 16.5392 5.91069 16.4306C5.9694 16.322 6.0004 16.2006 6.00094 16.0772L6.02062 12.6806C6.02164 12.5334 6.06563 12.3897 6.14719 12.2672L8.11031 9.33281C8.16661 9.24925 8.23917 9.17789 8.32366 9.12299C8.40814 9.06808 8.50283 9.03077 8.60205 9.01327C8.70128 8.99577 8.80301 8.99844 8.90119 9.02113C8.99936 9.04382 9.09195 9.08605 9.17344 9.14531L11.0306 10.3641C11.187 10.4767 11.3805 10.5253 11.5716 10.5L14.5209 10.1006C14.703 10.0762 14.8698 9.9858 14.9897 9.84656L17.0691 7.425C17.1859 7.28941 17.2504 7.1165 17.2509 6.9375V4.6875",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2714_3531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeIcon);
export default __webpack_public_path__ + "static/media/GlobeIcon.e0b3fcda971f83fa3c129c75e8ac1b45.svg";
export { ForwardRef as ReactComponent };